import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

const initialState = {
  fetching: false,
  adding: false,
  removing: false,
  attachmentsKey: getComponentKey(),
  institutionReportGroup: null,
  reportUploadAdding: false,
  reportUploadRemoving: false,
  reportUploadApplying: false,
  reportUploadsKey: getComponentKey()
}

export const actionTypes = {
  fetching: 'institutionReportGroup/fetching',
  fetched: 'institutionReportGroup/fetched',
  attachmentAdding: 'institutionReportGroup/attachment/adding',
  attachmentAdded: 'institutionReportGroup/attachment/added',
  attachmentRemoving: 'institutionReportGroup/attachment/removing',
  attachmentRemoved: 'institutionReportGroup/attachment/removed',
  submitting: 'institutionReportGroup/submitting',
  submitted: 'institutionReportGroup/submitted',
  reportUploadAdding: 'institutionReportGroup/reportUpload/adding',
  reportUploadAdded: 'institutionReportGroup/reportUpload/added',
  reportUploadRemoving: 'institutionReportGroup/reportUpload/removing',
  reportUploadRemoved: 'institutionReportGroup/reportUpload/removed',
  reportUploadApplying: 'institutionReportGroup/reportUpload/applying',
  reportUploadApplied: 'institutionReportGroup/reportUpload/applied',
  error: 'institutionReportGroup/error'
}

export const actionCreators = {
  get: (id) => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.institutionReportGroupService.get(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
      }).catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  addAttachments: (input) => (dispatch) => {
    dispatch({ type: actionTypes.attachmentAdding })
    context.api.institutionReportGroupService.addAttachments(input)
      .then(() => {
        dispatch({ type: actionTypes.attachmentAdded })
      }).catch(() => dispatch({ type: actionTypes.error, update: { adding: false } }))
  },
  removeAttachments: (input) => (dispatch) => {
    dispatch({ type: actionTypes.attachmentRemoving })
    context.api.institutionReportGroupService.removeAttachments(input)
      .then(() => {
        dispatch({ type: actionTypes.attachmentRemoved })
      }).catch(() => dispatch({ type: actionTypes.error, update: { removing: false } }))
  },
  addReportUploads: (input) => (dispatch) => {
    dispatch({ type: actionTypes.reportUploadAdding })
    context.api.institutionReportGroupService.addReportUploads(input)
      .then(() => {
        dispatch({ type: actionTypes.reportUploadAdded })
      }).catch(() => dispatch({ type: actionTypes.error, update: { reportUploadAdding: false } }))
  },
  removeReportUploads: (input) => (dispatch) => {
    dispatch({ type: actionTypes.reportUploadRemoving })
    context.api.institutionReportGroupService.removeReportUploads(input)
      .then(() => {
        dispatch({ type: actionTypes.reportUploadRemoved })
      }).catch(() => dispatch({ type: actionTypes.error, update: { reportUploadRemoving: false } }))
  },
  applyReportUpload: (input) => (dispatch) => {
    dispatch({ type: actionTypes.reportUploadApplying })
    context.api.reportExportService.importReportTemplateFromExcelFile(input)
      .then(() => {
        dispatch({ type: actionTypes.reportUploadApplied })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { reportUploadApplying: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return {
      ...state,
      fetching: false,
      institutionReportGroup: action.data
    }
    case actionTypes.attachmentAdding: return { ...state, adding: true }
    case actionTypes.attachmentAdded: return { ...state, adding: false, attachmentsKey: getComponentKey() }
    case actionTypes.attachmentRemoving: return { ...state, removing: true }
    case actionTypes.attachmentRemoved: return { ...state, removing: false, attachmentsKey: getComponentKey() }
    case actionTypes.submitting: return {
      ...state,
      institutionReportGroup: {
        ...state.institutionReportGroup,
        isBeingSubmitted: true
      }
    }
    case actionTypes.submitted: return {
      ...state,
      institutionReportGroup: {
        ...state.institutionReportGroup,
        isBeingSubmitted: false
      }
    }

    case actionTypes.reportUploadAdding: return { ...state, reportUploadAdding: true }
    case actionTypes.reportUploadAdded: return { ...state, reportUploadAdding: false, reportUploadsKey: getComponentKey() }
    case actionTypes.reportUploadRemoving: return { ...state, reportUploadRemoving: true }
    case actionTypes.reportUploadRemoved: return { ...state, reportUploadRemoving: false, reportUploadsKey: getComponentKey() }
    case actionTypes.reportUploadApplying: return { ...state, reportUploadApplying: true }
    case actionTypes.reportUploadApplied: return { ...state, reportUploadApplying: false }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/InstitutionReportGroup.js